import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-tms-tasinir-giris-bakiye-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';

import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {TmsTasinirGirisBakiyeService} from "../ctl-tms-tasinir-giris-bakiye.service";
import {TmsTifCikis} from "@dabnet-kamu/tms";
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-tms-tasinir-giris-bakiye-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-tms-tasinir-giris-bakiye-arama.component.html',
  styleUrls: ['./ctl-tms-tasinir-giris-bakiye-arama.component.scss'],
})
export class CtlTmsTasinirGirisBakiyeAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  @Output() private closePopup = new EventEmitter<string>();
  @Input() public islemFisCikisRowData: any
  @Input() public selectedDetayRowInfo: any
  @Input() public state: any
  @Input() public newTasinirCikisi!:any;
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  public selectedSingleData: any = null;
  gridControlsList$: Observable<DlistDto>;
  constructor(
    private service: Service,
    private tmsTasinirGirisBakiyeService:TmsTasinirGirisBakiyeService,
    public ortakService:OrtakService
  ) {


  }

  ngOnInit(): void {
    if(this.state==='New'){
      this.data = this.service.getData(this.newTasinirCikisi||this.islemFisCikisRowData);
    }else{
    this.data = this.service.getData(this.newTasinirCikisi||this.islemFisCikisRowData, this.selectedDetayRowInfo);
    }
    this.gridControlsList$ = this.tmsTasinirGirisBakiyeService.gridControlsList$;
    this.tmsTasinirGirisBakiyeService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedSingleData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedSingleData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }
  chooseBtnClick() {
    if(this.state==='New'){
    this.closePopup.emit(this.selectedData);
    }else{
      this.closePopup.emit(this.selectedSingleData);
    }
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }

  setSelectedRows($event: any) {
    this.selectedData=$event
  }
}

